@if (actions) {
  <div class="action-chooser-container" appTrapFocus [show]="show" (click)="choose(false)" #modal [class.hide]="!show" [class.show]="show" role="dialog" aria-modal="true" aria-label="post options">
    <div class="action-list">
      <div class="action-title" [innerHTML]="title | safe: 'html'"></div>
      @for (action of actions; track action) {
        <button class="btn btn-transparent btn-block action-item" (click)="choose(action, $event)" [innerHTML]="action | safe: 'html'"></button>
      }
      <button class="btn btn-transparent btn-block action-item cancel" (click)="choose(false, $event)">{{ "sphere.cancel" | translate }}</button>
    </div>
  </div>
}
